import type { ModalContentProps} from "@chakra-ui/react";
import { Modal, ModalBody, ModalContent, ModalOverlay, useMediaQuery } from "@chakra-ui/react";
import type { ReactNode } from "react";
import React from "react";
import { minWidth800BP } from "../../constants";
import { ButtonFixedLayout } from "../ButtonFixedLayout";
import { DisplayInfoCard } from "../DisplayInfoCard";


interface IProps {
	isOpen: boolean;
	onClose: VoidFunction;
	primaryButtonText: string;
	handlePrimaryButton: VoidFunction;
	isPrimaryButtonLoading?: boolean;
	secondaryButtonText?: string;
	handleSecondaryButton?: VoidFunction;
	isSecondaryButtonLoading?: boolean;
	icon: ReactNode;
	displayInfo: string;
	title?: string;
	chip?: ReactNode;
	description?: ReactNode | string;
	modalContentProps?: ModalContentProps;
	containerButtonProps?: React.CSSProperties;
}

export const ModalDisplayInfoCard = ({
	isOpen, onClose, description,
	displayInfo, title, handlePrimaryButton,
	handleSecondaryButton, chip, icon,
	primaryButtonText, secondaryButtonText,
	isPrimaryButtonLoading, isSecondaryButtonLoading,
	modalContentProps, containerButtonProps,
}: IProps) => {
	const [isLargerThan800] = useMediaQuery(minWidth800BP);

	return (
		<Modal isOpen={isOpen} onClose={onClose} size={isLargerThan800 ? "lg" : "4xl"} >
			<ModalOverlay/>
			<ModalContent margin={"auto 24px"} {...modalContentProps}>
				<ModalBody padding={"0px"}>
					<ButtonFixedLayout
						buttonStyles={{
							display: "flex", position: "relative",
							justifyContent: "flex-start",
							padding: isLargerThan800 ? "15px 18px 32px" : "0px 16px 32px",
							borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px",
						}}
						primaryButton={{
							onClick: () => handlePrimaryButton(),
							title: primaryButtonText,
							height: "48px",
							width: "210px",
							paddingX: "50px",
							paddingY: "10px",
							fontSize: {base: "16px", lg: "18px"},
							fontWeight: "500",
							lineHeight: "24px",
							isLoading: isPrimaryButtonLoading,
						}}
						secondaryButton={{
							onClick: () => {
								if (handleSecondaryButton) {
									handleSecondaryButton();
								}
							},
							title: secondaryButtonText,
							variant: "outline",
							height: "48px",
							width: "180px",
							fontSize: {base: "16px", lg: "18px"},
							fontWeight: "500",
							lineHeight: "24px",
							isLoading: isSecondaryButtonLoading,
							display: !secondaryButtonText ? "none" : "flex",
						}}
						containerButtonStyle={containerButtonProps}
					>
						<DisplayInfoCard
							gridProps={{backgroundColor: "transparent", padding: {base: "11px 35px 0 0", lg: "11px 45px 0 0"}, mb: "0px"}}
							icon={icon}
							title={title}
							displayInfo={displayInfo}
							displayProps={{fontSize: {base: "24px", lg: "32px"}, lineHeight: {base: "32px", lg: "40px"},marginTop: "-10px", marginBottom: chip ? "-8px" : "8px"}}
							description={description}
							descriptionProps={{marginTop: chip ? "-8px" : "8px", lineHeight: "24px"}}
							chip={chip}
						/>
					</ButtonFixedLayout>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default ModalDisplayInfoCard;
